// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"bY","header":"bZ","message":"b0","copyMessage":"b1","button":"b2"};